// scheduled-transaction/enums.ts
var ScheduledTransactionStatus = /* @__PURE__ */ ((ScheduledTransactionStatus2) => {
  ScheduledTransactionStatus2["PENDING"] = "pending";
  ScheduledTransactionStatus2["CHECKING"] = "checking";
  ScheduledTransactionStatus2["COMPLETED"] = "completed";
  ScheduledTransactionStatus2["FAILED"] = "failed";
  ScheduledTransactionStatus2["AWAITING_SETTLEMENT"] = "awaiting_settlement";
  return ScheduledTransactionStatus2;
})(ScheduledTransactionStatus || {});
var VerificationResultStatus = /* @__PURE__ */ ((VerificationResultStatus2) => {
  VerificationResultStatus2["COMPLETED"] = "completed";
  VerificationResultStatus2["FAILED"] = "failed";
  VerificationResultStatus2["PENDING"] = "pending";
  VerificationResultStatus2["UNKNOWN"] = "unknown";
  VerificationResultStatus2["FUNDS_DEBITED"] = "funds_debited";
  return VerificationResultStatus2;
})(VerificationResultStatus || {});

// scheduled-transaction/scheduled-transaction.schema.ts
import { z } from "zod";
var ScheduledTransactionSchema = z.object({
  id: z.string().uuid(),
  transactionId: z.string().uuid(),
  orderId: z.string(),
  customerId: z.string(),
  providerTransactionId: z.string(),
  effectiveDateTime: z.coerce.date(),
  status: z.nativeEnum(ScheduledTransactionStatus),
  checkAttempts: z.number().int().min(0),
  lastCheckAttemptAt: z.coerce.date().optional(),
  lastError: z.string().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  completedAt: z.coerce.date().optional()
});
var ScheduledTransactionWithTransactionSchema = ScheduledTransactionSchema.extend({
  transaction: z.object({
    checkSerialNumber: z.string().nullable()
  })
});
var TransactionVerificationResultSchema = z.object({
  success: z.boolean(),
  status: z.nativeEnum(VerificationResultStatus),
  providerStatus: z.string().optional(),
  message: z.string().optional(),
  metadata: z.record(z.unknown()).optional()
});
var CreateScheduledTransactionDtoSchema = z.object({
  transactionId: z.string().uuid(),
  orderId: z.string(),
  customerId: z.string(),
  providerTransactionId: z.string(),
  effectiveDateTime: z.coerce.date(),
  status: z.nativeEnum(ScheduledTransactionStatus).optional()
});
var UpdateScheduledTransactionDtoSchema = z.object({
  status: z.nativeEnum(ScheduledTransactionStatus).optional(),
  checkAttempts: z.number().int().min(0).optional(),
  lastCheckAttemptAt: z.coerce.date().optional(),
  lastError: z.string().optional(),
  completedAt: z.coerce.date().optional()
});
var FindScheduledTransactionsDtoSchema = z.object({
  status: z.nativeEnum(ScheduledTransactionStatus).optional(),
  effectiveDateBefore: z.coerce.date().optional(),
  effectiveDateAfter: z.coerce.date().optional(),
  limit: z.number().int().positive().optional(),
  offset: z.number().int().min(0).optional()
});
var ManualCheckRequestDtoSchema = z.object({
  scheduledTransactionId: z.string().uuid(),
  force: z.boolean().optional()
});
var ScheduledTransactionResponseDtoSchema = z.object({
  id: z.string().uuid(),
  transactionId: z.string().uuid(),
  orderId: z.string(),
  status: z.nativeEnum(ScheduledTransactionStatus),
  checkAttempts: z.number().int().min(0),
  effectiveDateTime: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  lastError: z.string().optional(),
  completedAt: z.string().optional()
});
var BulkCheckResultDtoSchema = z.object({
  totalChecked: z.number().int().min(0),
  successful: z.number().int().min(0),
  failed: z.number().int().min(0),
  pending: z.number().int().min(0),
  errors: z.array(
    z.object({
      scheduledTransactionId: z.string().uuid(),
      error: z.string()
    })
  )
});
var ScheduledTransactionQueryFiltersSchema = z.object({
  status: z.nativeEnum(ScheduledTransactionStatus).optional(),
  effectiveDateBefore: z.coerce.date().optional(),
  effectiveDateAfter: z.coerce.date().optional(),
  transactionId: z.string().uuid().optional(),
  orderId: z.string().optional(),
  customerId: z.string().optional(),
  minCheckAttempts: z.number().int().min(0).optional(),
  maxCheckAttempts: z.number().int().min(0).optional()
});
var ScheduledTransactionStatsSchema = z.object({
  totalPending: z.number().int().min(0),
  totalChecking: z.number().int().min(0),
  totalCompleted: z.number().int().min(0),
  totalFailed: z.number().int().min(0),
  averageCheckAttempts: z.number().min(0),
  oldestPendingDate: z.coerce.date().optional(),
  recentFailures: z.number().int().min(0)
});
export {
  BulkCheckResultDtoSchema,
  CreateScheduledTransactionDtoSchema,
  FindScheduledTransactionsDtoSchema,
  ManualCheckRequestDtoSchema,
  ScheduledTransactionQueryFiltersSchema,
  ScheduledTransactionResponseDtoSchema,
  ScheduledTransactionSchema,
  ScheduledTransactionStatsSchema,
  ScheduledTransactionStatus,
  ScheduledTransactionWithTransactionSchema,
  TransactionVerificationResultSchema,
  UpdateScheduledTransactionDtoSchema,
  VerificationResultStatus
};
